import { z } from 'zod'

import { SummaryProperty } from '../SummaryProperty'
import { useQuotation } from '../../context'

import { MreAcheelPackage, ProductEnum } from '../../../generated/graphql'

export const SummaryFormuleChoisie = () => {
  const { quotation } = useQuotation()

  let packageProduit
  let typePackageProduit: any
  if (quotation.details.products?.includes(ProductEnum.MreAcheel)) {
    packageProduit = quotation.details.mreAcheel?.packageOptionMAcheel
    typePackageProduit = MreAcheelPackage
  }

  const getPackageLabel = (packageProduit?: typeof typePackageProduit) => {
    switch (packageProduit) {
      case typePackageProduit.Basic:
        return 'Basic'
      case typePackageProduit.Comfort:
        return 'Comfort'
      case typePackageProduit.Premium:
        return 'Premium'
      default:
        return ''
    }
  }
  return (
    <SummaryProperty
      label="Formule choisie : "
      value={{
        packageProduit: packageProduit ?? typePackageProduit.Basic,
      }}
      displayValue={({ packageProduit }) => getPackageLabel(packageProduit)}
      schema={z.object({
        packageProduit: z.nativeEnum(typePackageProduit),
      })}
    />
  )
}
